import React, { useState, useMemo } from 'react'

interface Props {
  children: React.ReactNode
}

// The purpore of this context is to store the google map api
// and make it available throughout the app

interface Map {
  map: google.maps.Map | null | undefined
  setMap: (m: google.maps.Map | null | undefined) => void
}

export const MapContext = React.createContext<Map>({
  map: undefined,
  setMap: () => null,
})

const MapContextProvider = ({ children }: Props): JSX.Element => {
  const [map, setMap] = useState<google.maps.Map | null | undefined>(undefined)

  const values = useMemo(() => ({ map, setMap }), [map])

  return <MapContext.Provider value={values}>{children}</MapContext.Provider>
}

export default MapContextProvider
